var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("散点图")]),
      _vm._v(" "),
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "散点图根据数据的 x,y 确定散点的位置，气泡图是散点图的一种扩展，气泡图相较于散点图多一个维度，通过 "
        ),
        _c("strong", [_vm._v("areaField")]),
        _vm._v(" 字段可设置气泡的大小，默认为 areaField 值的大小，也可设置\n"),
        _c("strong", [_vm._v("areaRange")]),
        _vm._v(" 将 areaField 的值进行线性映射。气泡图还可以通过 "),
        _c("strong", [_vm._v("labelField")]),
        _vm._v(" 字段来设置显示的 label 。")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("areaField")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "气泡大小字段值，不设置此值则为散点图，可通过 style 自定义"
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_vm._v("null")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("areaRange")]),
            _vm._v(" "),
            _c("td", [_vm._v("面积映射，设置此值则将 areaField 进行线性映射")]),
            _vm._v(" "),
            _c("td", [_vm._v("Array")]),
            _vm._v(" "),
            _c("td", [_vm._v("null")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("labelField")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("气泡图中显示 label 的字段，可通过 style 自定义")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_vm._v("null")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("showGuideLine")]),
            _vm._v(" "),
            _c("td", [_vm._v("hover 时的辅助线,默认不显示辅助线")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("layoutWay")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴的相关属性")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("null")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("可设置 style 名称")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基本类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("point")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("点的样式,拥有Arc元素的全部属性")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("点 hover 样式，拥有Arc元素的全部属性")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("label")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("label 样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("guideline")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("指导线样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }